import { SubscriptionCancelReasons } from "content/Subscription";
import { CheckboxField, ReviewField, TextArea } from "components/formfields";
import { Field, Form, useFormikContext } from "formik";
import { useState } from "react";

function CancelSubscriptionForm() {
  const { values, setFieldValue, errors } = useFormikContext();
  const [isOtherSelected, setIsOtherSelected] = useState(false);

  const handleCheckboxChange = (reason, checked) => {
    const updatedReasons = checked
      ? [...values.reasons, reason]
      : values.reasons.filter((item) => item !== reason);

    setFieldValue("reasons", updatedReasons);
  };

  const handleOtherCheckboxChange = (e) => {
    const checked = e.target.checked;
    setIsOtherSelected(checked);
    setFieldValue("hasOtherReason", checked);
    if (checked) {
      setFieldValue("reasons", []);
    } else {
      setFieldValue("otherReason", "");
    }
  };

  return (
    <Form className="space-y-6">
      <div className="space-y-2">
        <div>
          <p className="mb-3 dark:text-white">
            What is the main reason for canceling your subscription?
          </p>
          <div className="space-y-2">
            {SubscriptionCancelReasons.map((reason, index) => (
              <CheckboxField
                key={index}
                name="reasons"
                label={reason}
                disabled={isOtherSelected}
                checked={values.reasons.includes(reason)}
                onChange={(e) => handleCheckboxChange(reason, e.target.checked)}
              />
            ))}
          </div>
        </div>

        <CheckboxField
          name="hasOtherReason"
          label="Other (please specify)"
          checked={isOtherSelected}
          onChange={handleOtherCheckboxChange}
        />
        {isOtherSelected && (
          <TextArea
            name="otherReason"
            placeholder="Please specify your reason"
            label="Other reason"
          />
        )}
      </div>
      <div>
        <Field
          name="rating"
          component={ReviewField}
          label="How satisfied were you with our platform overall?"
          onClick={(value) => setFieldValue("rating", value)}
        />
        {errors.rating && <p className="text-red-500">{errors.rating}</p>}
      </div>
      <div>
        <TextArea
          name="comment"
          placeholder="Any additional comment or suggestion?"
          label=""
        />
      </div>
      <button
        type="submit"
        className="w-full bg-teal-500 text-white py-2 px-4 rounded-md hover:bg-teal-600 transition-colors focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2"
      >
        Submit
      </button>
    </Form>
  );
}

export default CancelSubscriptionForm;
